/**
 * Constantes de coût de la rentabilité d'une session.
 *
 * Ces deux postes ne se négocient pas session par session : ce sont des règles
 * de l'organisme, identiques partout. Ils ne sont donc ni saisis dans le
 * dialogue des coûts, ni lus depuis `sessions.livret_apprenant` /
 * `sessions.commission_commerciale` — ces colonnes existent encore en base mais
 * ne pilotent plus rien.
 *
 * Les mêmes valeurs sont reprises côté PHP dans SessionModel (calcul de la
 * charge d'une session pour les listes) : toute modification doit être faite
 * des DEUX côtés.
 */

/** Commission commerciale, en pourcentage du chiffre d'affaires. */
export const COMMISSION_COMMERCIALE_PCT = 25;

/** Coût d'un livret de formation, par apprenant, en euros. */
export const LIVRET_APPRENANT_EUR = 7;
